module.exports = __webpack_public_path__ + "static/media/newsletter_icons.b9e03016.png";